module.exports = __webpack_public_path__ + "va.9d57ef0324ca3e9a90a4.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/va.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/va.svg
// module chunks = styles